
import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import BgNavPage from "@/components/bg-nav-page/index.vue";
import BgNavPageItem from "@/components/bg-nav-page-item/index.vue";
import ImageUploader from "@/components/image-uploader/index.vue";
import FileUploader from "@/components/file-uploader/index.vue";
import { ImageInfo } from "@/components/image-uploader/definitions";
import PropEditor, { PropEditorModel } from "./propEditor/index.vue";
import PoaEditor, { POAItem } from "./poaEditor/index.vue";
import ColorPanel from "@/components/colorPanel/index.vue";
import SizePanel from "@/components/sizePanel/index.vue";
import { Form } from "element-ui";
import {
  propertyParamTextAnalyze,
  addNewProduct,
  getSeasonLabel,
  getNewProductType,
  getNewProductTypeLabels,
  getSecondClothingCategory,
  getNewProductOldCategory,
} from "@/service/ewold/api/newProduct";
import { BgFormItem } from "@banggood/scm-fe";
import { ResNewProductCategoryDTO } from "@/service/supplier-meta/entity/ResNewProductCategoryDTO";
// import { ResNewProductClothingAndElectronicInfoDTO } from "@/service/ewold/entity/ResNewProductClothingAndElectronicInfoDTO";
import { NewProductCategoryOption } from "@/service/supplier-meta/entity/NewProductCategoryOption";
import { CascaderNode } from "element-ui/types/cascader-panel";
import { Cascader } from "element-ui/types";
import { getNewProductCategory } from "@/service/supplier-meta/api";
import { scrollElementFormErrorIntoView } from "@/utils";
import { SelectOption } from "@/service/common/entity/SelectOption";
import { isClothingCategory } from "@/service/supplier-meta/common/supplier-info-service";
import { defSubmitData } from "./defSubmitData";
import { getAliProductInfo } from "@/service/ewold/api/product";
import { AliProductInfo } from "@/service/ewold/entity/AliProductInfo";
import { getProductCategoryParamFileds } from "@/service/ewold/api/newProduct";
import {
  getNewProductDetail,
  GetNewProductDetailResponse,
} from "@/service/yttCodegen/ewold/api/newProduct";
import { getNewProductPropertyByNewProductId } from "@/service/yttCodegen/ewold/api/newProductProperty";
import { FileInfo } from "@/components/file-uploader/definitions";
import { SKUSpecItem } from "./poaEditor/index.vue";
import { getCategorySearch } from "@/service/yttCodegen/ewold/api/newProduct";
import { fillCategoryOptions } from "@/service/supplier-meta/common/supplier-info-service";
const AIRecognizeInputPlaceholder = `请按以下格式粘贴或输入文本，点击“智能识别”自动识别属性名称和属性值并自动填充，例：
主摄像素数：100万
机身重量：300g
图片格式：JPEG,PNG
包装清单：DJI Mini2 SEx1、DJI RC-N1 遥控器转接线（USB-C 接头）x1
`;
interface InvalidImageInfo extends ImageInfo {
  reason: string;
}
enum newProductTypeEnum {
  /** 电子类 */
  electronic = 0,
  /** 服装类 */
  clothing = 1,
  /** 其他 */
  other = 2,
}
function getSelectOptionLabelByValue(
  val: string | number,
  selectionOptions: SelectOption[]
): string {
  const option = selectionOptions.find((ele) => ele.value === val);
  return option?.label || "";
}
interface PropGroup {
  name: string;
  props: {
    label: string;
    value: string;
    required: boolean;
  }[];
}
@Component({
  components: {
    BgNavPage,
    BgNavPageItem,
    ImageUploader,
    FileUploader,
    PropEditor,
    ColorPanel,
    SizePanel,
    PoaEditor,
    BgFormItem,
  },
})
export default class AddNewProd extends Vue {
  @Ref("form") elForm!: Form;
  @Ref("imageUploader") imageUploader!: ImageUploader;
  @Ref("fileUploader") fileUploader!: FileUploader;
  @Ref("poaEditor") poaEditor!: PoaEditor;
  @Ref("categoryCascader") categoryCascader!: {
    getCheckedNodes: () => CascaderNode<Node, NewProductCategoryOption>[];
  } & Cascader;
  @Ref("colorPanel") colorPanel!: ColorPanel;
  @Ref("sizePanel") sizePanel!: SizePanel;
  labelWidth = "10em";
  form = {
    mainImages: [] as string[],
    assets: [] as FileInfo[],
    chineseName: "",
    category: [] as string[],
    brand: "",
    isExemptpostage: null as null | boolean,
    seasonLabels: [] as number[],
    newProductType: null as number | null,
    plugSpec: null as number | null,
    isAdapter: null as null | boolean,
    clothingCategory: "",
    subClothingCategory: null as null | number,
    clothingStyle: null as null | number,
    clothingComposition: "",
    clothingTagSize: null as null | number,
    fabricElasticity: null as null | number,
    baseDescription: "",
    fitAge: [] as number[],
    boxAble: null as null | boolean,
    boxLength: "",
    boxWidth: "",
    boxHeight: "",
    boxNum: "",
    boxWeight: "",
    packageProp: {
      label: "包装清单",
      value: [
        {
          name: "",
          quantity: null as number | null,
        },
      ],
    },
    propGroups: [] as PropGroup[],
  };
  /** 详情返回的待渲染的属性信息 */
  penddingPropGroups = [] as PropGroup[];
  link1688 = "";
  loading1688ProductInfo = false;
  assetFileList = [];
  categoryData: NewProductCategoryOption[] = [];
  AIRecognizeInput = "";
  AIRecognizing = false;
  mainImageLimit = {
    quantity: 10,
    size: 2 * 1024 * 1024,
  };
  assetsLimit = {
    size: 10 * 1024 * 1024,
  };
  lengthLimit = {
    chineseNameLimit: 250,
    brand: 200,
  };
  colors: string[] = [];
  sizes: string[] = [];
  sizeType = 0;
  seasonLabelOptions: SelectOption[] = [];
  newProductTypeOptions: SelectOption[] = [];
  plugSpecOptions: SelectOption[] = [];
  loadingPlugSpecOptions = false;
  clothingCategoryOptions: SelectOption[] = [];
  subClothingCategoryOptions: SelectOption[] = [];
  loadingClothingCategoryOptions = false;
  clothingStyleOptions: SelectOption[] = [];
  clothingTagSizeOptions: SelectOption[] = [];
  fabricElasticityOptions: SelectOption[] = [];
  fitAgeOptions: SelectOption[] = [];
  updatingSpec = false;
  get rules() {
    const decimal2Validator = (...args: any[]) => {
      const value = args[1] as string;
      const callback = args[2] as (msg?: string) => void;
      const reg = /^\d+(\.\d+)?$/;
      if (!reg.test(value)) {
        callback(`请输入有效数值，保留2位小数`);
      } else {
        callback();
      }
    };
    const intValidator = (...args: any[]) => {
      const value = args[1] as string;
      const callback = args[2] as (msg?: string) => void;
      const reg = /^\d+$/;
      if (!reg.test(value)) {
        callback(`请输入正整数`);
      } else {
        callback();
      }
    };
    return {
      mainImages: [
        { required: true, message: "请上传图片", trigger: "change" },
        {
          validator: async (...rest: unknown[]) => {
            const callback = rest[2] as (err?: string) => void;
            const imagesInfo = (await this.imageUploader
              .getImagesInfo()
              .catch(() => [])) as ImageInfo[];
            const invalidImagesInfo: InvalidImageInfo[] = [];
            imagesInfo.forEach((info) => {
              const minLen = 800;
              const reasons: string[] = [];

              // if (info.el.naturalWidth / info.el.naturalHeight !== ratio) {
              //   reasons.push(`图片宽高比不符合1:1`);
              // }
              // if (
              //   info.el.naturalWidth < minLen ||
              //   info.el.naturalHeight < minLen
              // ) {
              //   reasons.push(`图片宽和高必须都大于等于${minLen}px`);
              // }
              const maxSize = 2 * 1024 * 1024;
              if (info?.status !== "success" && info?.file.size > maxSize) {
                reasons.push(`图片大小超出2M`);
              }
              if (reasons.length) {
                invalidImagesInfo.push({
                  ...info,
                  reason: reasons.join("；"),
                });
              }
            });
            if (invalidImagesInfo.length > 0) {
              callback(JSON.stringify(invalidImagesInfo));
            } else {
              callback();
            }
          },
          trigger: "change",
        },
        {
          validator: async (...rest: unknown[]) => {
            const value = rest[1] as string[];
            const callback = rest[2] as (err?: string) => void;
            const minQuantity = 5;
            if (value && value.length < minQuantity) {
              callback(`请至少选择${minQuantity}张商品主图`);
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],
      assets: [
        {
          required: true,
          message: "请上传产品资料及认证证书",
          trigger: "change",
        },
        {
          validator: async (...rest: unknown[]) => {
            const callback = rest[2] as (err?: string) => void;
            const fileList = this.fileUploader.getFilesInfo();
            if (fileList.some((ele) => ele.status === "error")) {
              callback(`有上传失败的文件，请删除`);
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],
      chineseName: [
        { required: true, message: "请输入产品中文名称", trigger: "blur" },
        {
          validator: async (...rest: unknown[]) => {
            const callback = rest[2] as (err?: string) => void;
            const value = rest[1] as string;
            const maxLen = this.lengthLimit.chineseNameLimit;
            if (value && value.length > maxLen) {
              callback(`产品中文名称不能超过${maxLen}字符`);
            } else {
              callback();
            }
          },
        },
      ],
      category: [
        { required: true, message: "请选择产品分类", trigger: "change" },
      ],
      brand: [{ required: true, message: "请输入品牌名称", trigger: "blur" }],
      isExemptpostage: [
        { required: true, message: "请选择是否包邮", trigger: "change" },
      ],
      seasonLabels: [
        {
          required: this.isClothingCategory,
          message: "请选择四季标签",
          trigger: "change",
        },
      ],
      newProductType: [
        { required: true, message: "请选择产品类型", trigger: "change" },
      ],
      plugSpec: [
        {
          required: this.isElectronicProductType,
          message: "请选择插头规格",
          trigger: "change",
        },
      ],
      isAdapter: [
        {
          required: this.isElectronicProductType,
          message: "请选择是否转接头",
          trigger: "change",
        },
      ],
      clothingCategory: [
        {
          required: this.isClothingCategory,
          message: "请选择品类",
          trigger: "change",
        },
      ],
      subClothingCategory: [
        {
          required: this.isClothingCategory,
          message: "请选择二级品类",
          trigger: "change",
        },
      ],
      clothingStyle: [
        {
          required: this.isClothingCategory,
          message: "请选择款式",
          trigger: "change",
        },
      ],
      fabricElasticity: [
        {
          required: this.isClothingCategory,
          message: "请选择面料弹性",
          trigger: "change",
        },
      ],
      clothingComposition: [
        {
          required: this.isClothingCategory,
          message: "请输入面料成分",
          trigger: "blur",
        },
      ],
      clothingTagSize: [
        {
          required: this.isClothingCategory,
          message: "请选择服装tag尺码标准",
          trigger: "change",
        },
      ],
      fitAge: [
        {
          required: this.isClothingCategory,
          message: "请选择适用年龄",
          trigger: "change",
        },
      ],
      boxAble: [{ required: true, message: "请选择", trigger: "change" }],
      boxLength: [
        { required: this.form.boxAble, message: "请输入", trigger: "blur" },
        {
          validator: decimal2Validator,
          trigger: "blur",
        },
      ],
      boxWidth: [
        {
          required: this.form.boxAble,
          message: "请输入最长边",
          trigger: "blur",
        },
        {
          validator: decimal2Validator,
          trigger: "blur",
        },
      ],
      boxHeight: [
        {
          required: this.form.boxAble,
          message: "请输入次长边",
          trigger: "blur",
        },
        {
          validator: decimal2Validator,
          trigger: "blur",
        },
      ],
      boxNum: [
        {
          required: this.form.boxAble,
          message: "请输入每箱货量",
          trigger: "blur",
        },
        {
          validator: intValidator,
          trigger: "blur",
        },
      ],
      boxWeight: [
        {
          required: this.form.boxAble,
          message: "请输入整箱重量",
          trigger: "blur",
        },
        {
          validator: decimal2Validator,
          trigger: "blur",
        },
      ],
    };
  }
  get packagePropItemRules() {
    return {
      name: [
        { required: true, message: "请输入产品/配件名称", trigger: "blur" },
        {
          validator: (
            rules: unknown,
            value: string,
            callback: (msg?: string) => void
          ) => {
            if (!value.trim()) {
              callback("产品/配件名称不能为空");
            } else if (value.length > 20) {
              callback("产品/配件名称长度不能超过20字符");
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],
      quantity: [
        { required: true, message: "请输入数量", trigger: "blur" },
        {
          validator: (
            rules: unknown,
            value: string,
            callback: (msg?: string) => void
          ) => {
            const numRegExp = /^[+-]?\d+$/;
            if (!numRegExp.test(value)) {
              callback("请输入有效数值");
            } else if (+value <= 0 || +value >= 999) {
              callback("数量必须大于0且小于999");
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],
    };
  }
  get isElectronicProductType() {
    return this.form.newProductType === newProductTypeEnum.electronic;
  }
  get isClothingProductType() {
    return this.form.newProductType === newProductTypeEnum.clothing;
  }
  catagoryCascaderPanelProps = {
    label: "cn_name",
    value: "id",
    children: "children",
    checkStrictly: false,
    expandTrigger: "hover",
    lazy: true,
    leaf: "is_leaf",
    async lazyLoad(
      node: CascaderNode<Node, NewProductCategoryOption>,
      resolve: (data: NewProductCategoryOption[]) => void
    ) {
      //
      if (node.children?.length) {
        resolve([]);
        return;
      }
      const id = node.data?.id;
      if (!id) {
        return;
      }
      const res = await getNewProductCategory(id);
      if (res.is_success && Array.isArray(res.result)) {
        resolve(res.result);
      } else {
        resolve([]);
      }
    },
  };
  AIRecognizeInputPlaceholder = AIRecognizeInputPlaceholder;
  isClothingCategory = false;
  propEditorState = {
    groupName: "其他",
    visible: false,
  };
  submitting = false;
  get categoryOptions() {
    return this.categoryData;
  }
  async mounted() {
    this.getOptions();
    this.categoryData = await this.getCategoryData();
    this.renderSavedData(async (data) => {
      if (data?.thirdparty_category_id) {
        // 获取品类信息
        const res = await getCategorySearch({
          id: data.thirdparty_category_id,
        });
        const fullIdStr =
          Array.isArray(res?.result) && res.result[0]
            ? res.result[0].full_id || ""
            : "";
        const idPath = fullIdStr.replace(/^\||\|$/g, "").split("|");
        if (!idPath.length) {
          return;
        }
        this.form.category = idPath;
        await fillCategoryOptions(idPath, this.categoryData);
        setTimeout(() => {
          this.handleCategoryChange();
        });
      }
    });
  }
  getNewProductId() {
    if (this.$route.query.id) {
      return +this.$route.query.id;
    }
  }
  async renderSavedData(
    fetchedCallback?: (data: GetNewProductDetailResponse["result"]) => void
  ) {
    const newProductId = this.getNewProductId();
    const id = newProductId ? String(this.$route.query.id) : "";
    if (!id) {
      return;
    }
    const res = await getNewProductDetail({
      id,
    });
    console.log("res", res);
    if (res.is_success && res.result) {
      if (fetchedCallback) {
        fetchedCallback(res.result);
      }
      const data = res.result;
      this.form.mainImages = (data.picture_url || []).map(
        (ele) => ele.picture_url || ""
      );
      this.form.assets =
        data.attachment?.map((ele, index) => ({
          index: index,
          url: ele.file_path || "",
          name: ele.file_name,
          status: "success",
        })) || [];
      this.link1688 = data.product_link || "";
      this.form.chineseName = data.chinese_name || "";
      this.form.brand = data.brands_name || "";
      this.form.isExemptpostage =
        typeof data.is_exemptpostage === "number"
          ? !!data.is_exemptpostage
          : null;
      this.form.newProductType =
        typeof data.new_product_type === "number"
          ? data.new_product_type
          : null;
      this.form.plugSpec =
        typeof data.thirdparty_plug_specifications_id === "number"
          ? data.thirdparty_plug_specifications_id
          : null;
      this.form.isAdapter =
        typeof data.is_adapter === "boolean" ? data.is_adapter : null;
      try {
        if (typeof data.thirdparty_season_label_name === "string") {
          this.form.seasonLabels = JSON.parse(
            data.thirdparty_season_label_name
          ).map((ele: { key: number }) => ele.key);
        }
      } catch (err) {
        console.log(err);
      }
      try {
        if (typeof data.thirdparty_suitable_age_name === "string") {
          this.form.fitAge = JSON.parse(data.thirdparty_suitable_age_name).map(
            (ele: { key: number }) => ele.key
          );
        }
      } catch (err) {
        console.log(err);
      }
      this.form.clothingCategory = data.thirdparty_clothing_category_id || "";
      this.handleClothingCategoryChange(this.form.clothingCategory);
      this.form.subClothingCategory =
        typeof data.thirdparty_clothing_second_category_id === "number"
          ? data.thirdparty_clothing_second_category_id
          : null;
      this.form.clothingStyle =
        typeof data.thirdparty_clothing_style_id === "number"
          ? data.thirdparty_clothing_style_id
          : null;
      this.form.fabricElasticity =
        typeof data.thirdparty_clothing_elasticity_id === "number"
          ? data.thirdparty_clothing_elasticity_id
          : null;
      this.form.clothingComposition = data.clothing_composition_name || "";
      this.form.clothingTagSize =
        typeof data.thirdparty_tag_size_id === "number"
          ? data.thirdparty_tag_size_id
          : null;
      this.form.baseDescription = data.base_description || "";
      this.form.boxAble =
        typeof data.box_able === "number" ? !!data.box_able : null;
      if (this.form.boxAble) {
        this.form.boxLength = data.box_length ? String(data.box_length) : "";
        this.form.boxWidth = data.box_width ? String(data.box_width) : "";
        this.form.boxHeight = data.box_high ? String(data.box_high) : "";
        this.form.boxNum = data.box_num ? String(data.box_num) : "";
        this.form.boxWeight = data.box_weight ? String(data.box_weight) : "";
      }
      if (Array.isArray(data.package_descriptions)) {
        this.form.packageProp.value =
          data.package_descriptions.map((ele) => ({
            name: ele.name || "",
            quantity: ele.quantity || null,
          })) || [];
      }
      if (Array.isArray(data.etc_property_descriptions)) {
        const propGroups = [
          {
            name: "其他",
            props: data.etc_property_descriptions.map((ele: any) => ({
              label: ele.key,
              value: ele.value,
              required: false,
            })),
          },
        ];
        this.form.propGroups = propGroups;
        this.penddingPropGroups = propGroups;
      }
      // POA信息
      getNewProductPropertyByNewProductId({
        new_product_id: id,
      }).then((res) => {
        if (res.is_success && Array.isArray(res.result) && res.result.length) {
          const items: POAItem[] =
            res.result.map((ele) => ({
              images: (ele.image_list || []).map(
                (img) => img.picture_url || ""
              ),
              color: ele.poa_color || "",
              size: ele.poa_size || "",
              sizeType: ele.poa_size_type,
              featureLabels:
                ele.thirdparty_feature_callout?.map(
                  (ele: any) =>
                    ({
                      label: ele.value,
                      value: ele.key,
                    } as any)
                ) || [],
              price: typeof ele.price === "number" ? String(ele.price) : "",
              volume: {
                length:
                  typeof ele.box_length === "number"
                    ? String(ele.box_length)
                    : "",
                width:
                  typeof ele.box_width === "number"
                    ? String(ele.box_width)
                    : "",
                height:
                  typeof ele.box_high === "number" ? String(ele.box_high) : "",
              },
              weight: typeof ele.weight === "number" ? String(ele.weight) : "",
              arrivalDays:
                typeof ele.arrival_days === "number"
                  ? String(ele.arrival_days)
                  : "",
              minOrderQuantity:
                typeof ele.min_num === "number" ? String(ele.min_num) : "",
            })) || [];
          this.poaEditor.setPoaItems(items);
        } else {
          const skuSpecData = {
            items: [
              {
                featureLabels: (() => {
                  if (typeof data.thirdparty_feature_callout === "string") {
                    try {
                      const res = JSON.parse(data.thirdparty_feature_callout);
                      return res.map((ele: { key: string | number }) =>
                        String(ele.key)
                      );
                    } catch (err) {
                      console.log(err);
                    }
                  }
                  return [];
                })(),
                price: typeof data.price === "number" ? String(data.price) : "",
                weight:
                  typeof data.weight === "number" ? String(data.weight) : "",
                arrivalDays:
                  typeof data.arrival_days === "number"
                    ? String(data.arrival_days)
                    : "",
                minOrderQuantity:
                  typeof data.min_num === "number" ? String(data.min_num) : "",
                volume: {
                  length:
                    typeof data.forecast_length === "number"
                      ? String(data.forecast_length)
                      : "",
                  width:
                    typeof data.forecast_width === "number"
                      ? String(data.forecast_width)
                      : "",
                  height:
                    typeof data.forecast_height === "number"
                      ? String(data.forecast_height)
                      : "",
                },
              },
            ] as SKUSpecItem[],
          };
          this.poaEditor.setSkuSpecForm(skuSpecData);
        }
      });
    }
  }
  isNewProductTypeOptionDisabled(val: number) {
    return !this.isClothingCategory && val === newProductTypeEnum.clothing;
  }
  getOptions() {
    getSeasonLabel().then((res) => {
      if (Array.isArray(res.result)) {
        this.seasonLabelOptions = res.result.map((ele) => ({
          label: ele.value,
          value: ele.key,
        }));
      }
    });
    getNewProductType().then((res) => {
      if (Array.isArray(res.result)) {
        this.newProductTypeOptions = res.result.map((ele) => ({
          label: ele.value,
          value: ele.key,
        }));
      }
    });
    // 服装相关选项
    if (
      this.plugSpecOptions.length === 0 &&
      !this.loadingClothingCategoryOptions
    ) {
      const id = 0; // 请求服装类用此id
      getNewProductTypeLabels({ id }).then((res) => {
        if (Array.isArray(res.result?.clothing_category)) {
          this.clothingCategoryOptions = (
            res.result?.clothing_category || []
          ).map((ele) => ({
            label: ele.value,
            value: ele.key,
          }));
        }
        if (Array.isArray(res.result?.clothing_style)) {
          this.clothingStyleOptions = (res.result?.clothing_style || []).map(
            (ele) => ({
              label: ele.value,
              value: ele.key,
            })
          );
        }
        if (Array.isArray(res.result?.clothing_tag_size)) {
          this.clothingTagSizeOptions = (
            res.result?.clothing_tag_size || []
          ).map((ele) => ({
            label: ele.value,
            value: ele.key,
          }));
        }
        if (Array.isArray(res.result?.fabric_elasticity)) {
          this.fabricElasticityOptions = (
            res.result?.fabric_elasticity || []
          ).map((ele) => ({
            label: ele.value,
            value: ele.key,
          }));
        }
        if (Array.isArray(res.result?.fit_age)) {
          this.fitAgeOptions = (res.result?.fit_age || []).map((ele) => ({
            label: ele.value,
            value: ele.key,
          }));
        }
      });
    }
  }
  isArrayString(str: string) {
    try {
      const json = JSON.parse(str);
      return Array.isArray(json);
    } catch (err) {
      return false;
    }
  }
  async load1688ProductInfo() {
    if (this.loading1688ProductInfo) {
      return;
    }
    const url = this.link1688 || "";
    const match = url.match(/detail.1688.com\/offer\/(.*?)\.html/);
    const itemId = match ? match[1] : "";
    if (!itemId) {
      this.$message.warning("无效的1688链接");
      return;
    }
    this.loading1688ProductInfo = true;
    const res = await getAliProductInfo({
      aliProductId: itemId,
    });
    this.loading1688ProductInfo = false;
    console.log(res);
    if (res.is_success && res.result) {
      if (res.result.subject) {
        //中文名
        this.form.chineseName = res.result.subject;
      }
      if (Array.isArray(res.result.skuinfos)) {
        const poaItems = this.genPOAItemsBy1688ProductInfos(
          res.result.skuinfos
        );
        this.poaEditor.setPoaItems(poaItems);
      }
    }
  }
  genPOAItemsBy1688ProductInfos(skuinfos: AliProductInfo[]): POAItem[] {
    const items = skuinfos.map(
      (info) =>
        ({
          images: info.skuImageUrls,
          color: info.color,
          size: info.size,
          featureLabels: [],
          price: String(info.costPrice || info.price),
          volume: {
            length: "",
            width: "",
            height: "",
          },
          weight: "",
          arrivalDays: "",
          minOrderQuantity: "",
        } as POAItem)
    );
    return items;
  }
  async handleMainImagesChange() {
    console.log("handleMainImagesChange");
    this.elForm.validateField("mainImages");
  }
  onExceedMainImageQuantityLimit() {
    this.$message.warning(`做多上传${this.mainImageLimit.quantity}张图片`);
  }
  addOnterProp() {
    this.propEditorState.visible = true;
  }
  handleAssetsChange(files: any[]) {
    //
  }
  handlePropEditorDone(data: PropEditorModel) {
    let group = this.form.propGroups.find(
      (group) => group.name === data.groupName
    );
    if (!group) {
      group = {
        name: data.groupName,
        props: [],
      };
      this.form.propGroups.push(group);
    }
    group.props.push({
      label: data.propName,
      value: data.propValue || "",
      required: false,
    });
    console.log(group);
    this.propEditorState.visible = false;
  }
  async getCategoryData(): Promise<ResNewProductCategoryDTO[]> {
    const res = await getNewProductCategory();
    if (res.is_success && res.result) {
      return res.result;
    }
    return [];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  checkAIResValid(res: any) {
    return (
      Array.isArray(res) && res.every((ele) => ele && typeof ele === "object")
    );
  }
  removePackagePropItem(index: number) {
    if (index === 0 && this.form.packageProp.value.length === 1) {
      this.$message.warning("至少保留一条包装清单数据");
      return;
    }
    this.form.packageProp.value.splice(index, 1);
    this.elForm.clearValidate([
      `packageProp.value.${index}.name`,
      `packageProp.value.${index}.quantity`,
    ]);
  }
  addPackagePropItem() {
    const maxQuantity = 20;
    if (this.form.packageProp.value.length >= maxQuantity) {
      this.$message(`最多添加${maxQuantity}条包装清单数据`);
      return;
    }
    this.form.packageProp.value.push({
      name: "",
      quantity: null,
    });
  }
  removeProp(groupIndex: number, propIndex: number) {
    this.form.propGroups[groupIndex].props.splice(propIndex, 1);
  }
  addProp(groupIndex: number) {
    this.form.propGroups[groupIndex].props.push({
      label: "",
      value: "",
      required: false,
    });
  }
  async AIRec() {
    if (!this.AIRecognizeInput) {
      this.$message.warning("请输入/粘贴文字");
      return;
    }
    this.AIRecognizing = true;
    const res = await propertyParamTextAnalyze(this.AIRecognizeInput);
    this.AIRecognizing = false;
    const otherProps: { label: string; value: string; required: boolean }[] =
      [];
    if (
      res.is_success &&
      this.checkAIResValid(res.result) &&
      res.result?.length
    ) {
      // ai识别
      res.result?.forEach((ele) => {
        console.log("Object.entries(ele)", Object.entries(ele));
        Object.entries(ele).forEach(([key, value]) => {
          otherProps.push({
            label: key,
            value: value,
            required: false,
          });
        });
      });
    } else {
      //人工处理
      const matches = this.AIRecognizeInput.match(/[^:：]+[:：][^:：]+\s/g);
      if (matches?.length) {
        matches.forEach((m) => {
          const kv = m.split(/:|：/).map((ele) => ele.trim());
          const [label, value] = kv;
          otherProps.push({
            label,
            value,
            required: false,
          });
        });
      }
    }
    if (otherProps.length) {
      this.mergeOtherProps(otherProps, true);
      this.$message.success("已识别");
      this.AIRecognizeInput = "";
    } else {
      this.$message.error("智能识别失败，请调整文本后重试");
    }
  }
  mergeOtherProps(
    otherProps: { label: string; value: string; required: boolean }[],
    overwrite?: boolean
  ) {
    const otherGroup = this.form.propGroups.find((ele) => ele.name === "其他");
    if (!otherGroup) {
      this.form.propGroups.push({
        name: "其他",
        props: otherProps,
      });
    } else {
      otherProps.forEach((ele) => {
        const sameIndex = otherGroup.props.findIndex(
          (p) => p.label === ele.label
        );
        // 覆盖
        if (
          sameIndex !== -1 &&
          overwrite &&
          otherGroup.props[sameIndex].value
        ) {
          ele.required = otherGroup.props[sameIndex].required;
          ele.value = otherGroup.props[sameIndex].value;
          otherGroup.props.splice(sameIndex, 1, ele);
        } else {
          otherGroup.props.push(ele);
        }
      });
    }
  }
  handleColorPanelChange(data: { label: string; value: string }[]) {
    if (this.updatingSpec) {
      return;
    }
    this.colors = data.map((ele) => ele.value);
    const items = this.genPoaItem(this.colors, this.sizes, this.sizeType);
    this.poaEditor.setPoaItems(items);
  }
  handleSizePanelChange(data: string[], sizeType: number) {
    if (this.updatingSpec) {
      return;
    }
    console.log("handleSizePanelChange", data);
    this.sizes = data;
    this.sizeType = sizeType;
    const items = this.genPoaItem(this.colors, this.sizes, this.sizeType);
    this.poaEditor.setPoaItems(items);
  }
  genPoaItem(colors: string[], sizes: string[], sizeType: number) {
    const genItem = (color: string, size: string) => ({
      color,
      size,
      sizeType,
      images: [],
      featureLabels: [],
      price: "",
      volume: {
        length: "",
        width: "",
        height: "",
      },
      weight: "",
      arrivalDays: "",
      minOrderQuantity: "",
    });
    const items: POAItem[] = [];
    if (sizes.length === 0) {
      colors.forEach((color) => {
        items.push(genItem(color, ""));
      });
    } else if (colors.length === 0) {
      sizes.forEach((size) => {
        items.push(genItem("", size));
      });
    } else {
      colors.forEach((color) => {
        sizes.forEach((size) => {
          items.push(genItem(color, size));
        });
      });
    }

    return items;
  }
  removeMainImage(index: number) {
    this.imageUploader.remove(index);
  }
  handleCategoryChange() {
    {
      const leafCategoryId = this.form.category[this.form.category.length - 1];
      if (leafCategoryId !== undefined) {
        this.loadSpecLabelsByCategoryId(leafCategoryId);
      }
    }
    const chechedCategoryNodes = this.categoryCascader.getCheckedNodes();
    if (chechedCategoryNodes) {
      const selectedCategory = chechedCategoryNodes[0].data;
      let firstLevelCategoryId = "";
      let isClothing = false;
      firstLevelCategoryId = selectedCategory.full_id
        .replace(/^\||\|$/g, "")
        .split("|")[0]
        .trim();
      isClothing = isClothingCategory(firstLevelCategoryId);
      this.isClothingCategory = isClothing;
    } else {
      this.isClothingCategory = false;
    }
    // 服装类型值
    const newProductTypeClothingVal = 1;
    if (
      !this.isClothingCategory &&
      this.form.newProductType === newProductTypeClothingVal
    ) {
      this.form.newProductType = null;
    } else if (this.isClothingCategory && this.form.newProductType === null) {
      this.form.newProductType = newProductTypeClothingVal;
    }
  }
  async loadSpecLabelsByCategoryId(categoryId: string) {
    let overwrite = false;
    // 重置包装属性
    if (
      Array.isArray(this.penddingPropGroups) &&
      this.penddingPropGroups.length
    ) {
      this.form.propGroups = this.penddingPropGroups;
      this.penddingPropGroups = [];
      overwrite = true;
    } else {
      this.form.propGroups = [];
    }
    const res = await getProductCategoryParamFileds({
      cateId: categoryId,
    });
    if (Array.isArray(res.result)) {
      const otherProps =
        res.result?.map((ele) => ({
          label: ele.param_name,
          value: "",
          required: ele.required,
        })) || [];
      this.mergeOtherProps(otherProps, overwrite);
    }
  }
  handleNewProductTypeChange(val: number | null) {
    if (val === null) {
      return;
    }
    switch (val) {
      case 0: //电子
        if (this.plugSpecOptions.length === 0 && !this.loadingPlugSpecOptions) {
          const id = 1; // 请求电子类用此id
          getNewProductTypeLabels({ id }).then((res) => {
            if (Array.isArray(res.result?.plug_specifications)) {
              this.plugSpecOptions = (
                res.result?.plug_specifications || []
              ).map((ele) => ({
                label: ele.value,
                value: ele.key,
              }));
            }
          });
        }
        break;
    }
  }
  handleClothingCategoryChange(val: string) {
    this.form.subClothingCategory = null;
    if (val) {
      getSecondClothingCategory({ key: val }).then((res) => {
        if (Array.isArray(res.result) && this.form.clothingCategory === val) {
          this.subClothingCategoryOptions = res.result.map((ele) => ({
            label: ele.value,
            value: ele.key,
          }));
        }
      });
    }
  }

  handlePOALengthChange() {
    if (!this.poaEditor) {
      return;
    }
    const items = this.poaEditor.getPoaItems();
    const colors: string[] = [];
    const sizes: string[] = [];
    items.forEach((item) => {
      if (colors.indexOf(item.color) === -1) {
        colors.push(item.color);
      }
      if (sizes.indexOf(item.size) === -1) {
        sizes.push(item.size);
      }
    });
    this.updatingSpec = true;
    this.colors.forEach((color) => {
      if (colors.indexOf(color) === -1) {
        this.colorPanel.removeColorByValue(color);
      }
    });
    this.sizes.forEach((size) => {
      if (sizes.indexOf(size) === -1) {
        this.sizePanel.removeSizeByValue(size);
      }
    });
    this.colors = colors.filter((ele) => !!ele);
    this.sizes = sizes.filter((ele) => !!ele);
    this.colorPanel.setCheckedValues(this.colors);
    this.sizePanel.setCheckedValues(this.sizes);
    setTimeout(() => {
      this.updatingSpec = false;
    });
  }
  async validate() {
    const formValid = await this.elForm.validate().catch(() => false);
    const poaValid = await this.poaEditor.validate().catch(() => false);
    if (!formValid) {
      scrollElementFormErrorIntoView(this.elForm);
      this.$message.warning(`请按要求填写新品信息`);
      return false;
    }
    if (!poaValid) {
      this.poaEditor.scrollErrorIntoView();
      this.$message.warning(`请按要求填写规格（POA）信息`);
      return false;
    }
    return true;
  }
  async getOldCategoryByNewCategoryId(id: string) {
    const res = await getNewProductOldCategory({ id });
    if (res.is_success && res.result) {
      return res.result;
    }
  }
  async getSubmitData() {
    const pkgDetails = (() => {
      return this.form.packageProp.value.map((ele) => ({
        name: ele.name,
        quantity: ele.quantity,
      }));
    })();
    const otherProps = (() => {
      const group = this.form.propGroups.find((ele) => ele.name === "其他");
      return group?.props.map((ele) => ({
        key: ele.label,
        value: ele.value,
      }));
    })();
    const poaInfos = (() => {
      const poaItems = this.poaEditor.getPoaItems();
      return poaItems.map((ele) => ({
        property_images: ele.images.map((ele, index) => ({
          is_default: index === 0 ? 1 : 0,
          path: ele,
        })),
        poa_color: ele.color,
        poa_size: ele.size,
        poa_size_type: ele.sizeType,
        thirdparty_feature_callout: ele.featureLabels.map((label) => ({
          key: label.value,
          value: label.label,
        })),
        price: +ele.price,
        weight: +ele.weight,
        box_length: +ele.volume.length,
        box_width: +ele.volume.width,
        box_high: +ele.volume.height,
        arrival_days: +ele.arrivalDays,
        min_num: +ele.minOrderQuantity,
        status: 1, // 状态(0：草稿(不用)，1：待采用，2：已采用，3：取消采用) ,
      }));
    })();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chechedCategoryNodes = this.categoryCascader.getCheckedNodes();
    let categoryId = "";
    let categoryName = "";
    let categoryCnName = "";
    if (chechedCategoryNodes) {
      const selectedCategory = chechedCategoryNodes[0].data;
      categoryId = selectedCategory.id;
      categoryName = selectedCategory.en_name;
      categoryCnName = selectedCategory.full_cn_name;
    }
    const data: { [x: string]: unknown } = {
      img_link: this.form.mainImages,
      img_ids: [], //删除的图片
      default_img_link: this.form.mainImages[0],
      certification_link: this.fileUploader.getFilesInfo().map((ele) => ({
        file_name: ele.file?.name || ele.name || "",
        file_path: ele.url,
      })),
      certification_ids: [],
      ewd_recommend_type: 0, // 推荐类型：0-普通推新
      product_link: this.link1688 || "无",
      chinese_name: this.form.chineseName,
      thirdparty_category_id: categoryId, //新分类id
      thirdparty_category_name: categoryName, //新分类英文名
      thirdparty_category_cn_name: categoryCnName, //新分类中文名
      brands_name: this.form.brand,
      new_product_type: this.form.newProductType,
      is_exemptpostage: this.form.isExemptpostage ? 1 : 0,
      base_description: this.form.baseDescription,
      box_able: this.form.boxAble ? 1 : 0,
      package_description: pkgDetails,
      etc_property_descriptions: otherProps || [],
      poa_infos: poaInfos,
      del_poa: [],
      is_show: this.isClothingCategory, //是否显示四季标签，服装特性，适用年龄
      status: 1, // 状态(0：草稿(不用)，1：待采用，2：已采用，3：取消采用) ,
    };
    const id = this.getNewProductId();
    if (id) {
      data.id = id;
    }
    if (this.isClothingCategory) {
      //四季标签
      data.thirdparty_season_label_name = this.isClothingCategory //四季标签
        ? this.form.seasonLabels.map((ele) => ({
            key: ele,
            value: getSelectOptionLabelByValue(ele, this.seasonLabelOptions),
          }))
        : [];
      // 适用年龄
      data.thirdparty_suitable_age_name = this.form.fitAge.map((ele) => ({
        key: ele,
        value: getSelectOptionLabelByValue(ele, this.fitAgeOptions),
      }));
    }
    if (data.new_product_type === newProductTypeEnum.electronic) {
      // 电子类
      if (typeof this.form.plugSpec === "number") {
        data.thirdparty_plug_specifications_id = this.form.plugSpec;
        data.thirdparty_plug_specifications_name = getSelectOptionLabelByValue(
          this.form.plugSpec,
          this.plugSpecOptions
        );
      }
      if (typeof this.form.isAdapter === "boolean") {
        data.is_adapter = this.form.isAdapter;
      }
    }
    if (data.new_product_type === newProductTypeEnum.clothing) {
      // 服装类
      // 品类
      data.thirdparty_clothing_category_id = this.form.clothingCategory;
      data.thirdparty_clothing_category_name = getSelectOptionLabelByValue(
        this.form.clothingCategory,
        this.clothingCategoryOptions
      );
      // 二级服装品类
      data.thirdparty_clothing_second_category_id =
        this.form.subClothingCategory;
      data.thirdparty_clothing_second_category_name =
        getSelectOptionLabelByValue(
          this.form.subClothingCategory as number,
          this.subClothingCategoryOptions
        );
      // 款式
      data.thirdparty_clothing_style_id = this.form.clothingStyle;
      data.thirdparty_clothing_style_name = getSelectOptionLabelByValue(
        this.form.clothingStyle as number,
        this.clothingStyleOptions
      );
      // 面料弹性
      data.thirdparty_clothing_elasticity_id = this.form.fabricElasticity;
      data.thirdparty_clothing_elasticity_name = getSelectOptionLabelByValue(
        this.form.fabricElasticity as number,
        this.fabricElasticityOptions
      );
      // 面料成分
      data.clothing_composition_name = this.form.clothingComposition;
      // 服装tag尺码标准
      data.thirdparty_tag_size_id = this.form.clothingTagSize;
      data.thirdparty_tag_size_name = getSelectOptionLabelByValue(
        this.form.clothingTagSize as number,
        this.clothingTagSizeOptions
      );
    }
    if (this.form.boxAble) {
      //整箱配送
      data.box_length = +this.form.boxLength;
      data.box_width = +this.form.boxWidth;
      data.box_high = +this.form.boxHeight;
      data.box_num = +this.form.boxNum;
      data.box_weight = +this.form.boxWeight;
    }
    if (!this.poaEditor.hasPoaItem) {
      // 没有POA
      const skuSpec = this.poaEditor.getSKUSpec();
      data.price = +skuSpec.price;
      data.weight = +skuSpec.weight;
      data.arrival_days = +skuSpec.arrivalDays;
      data.forecast_length = +skuSpec.volume.length;
      data.forecast_width = +skuSpec.volume.width;
      data.forecast_height = +skuSpec.volume.height;
      data.min_num = +skuSpec.minOrderQuantity;
      data.thirdparty_feature_callout = skuSpec.featureLabels.map((label) => ({
        key: label,
        value: this.poaEditor.getFeatureLabelNameById(+label),
      }));
    }
    // 通过新品id获取旧品信息
    const oldCategoryInfo = await this.getOldCategoryByNewCategoryId(
      categoryId
    );
    if (
      oldCategoryInfo &&
      Array.isArray(oldCategoryInfo.mapping_list) &&
      oldCategoryInfo.mapping_list[0]
    ) {
      data.thirdparty_old_category_id =
        oldCategoryInfo.mapping_list[0].ebayuk_cate_id;
      data.thirdparty_old_category_name =
        oldCategoryInfo.mapping_list[0].ebayuk_cate_en_full_name;
    }
    return Object.assign({}, defSubmitData, data);
  }
  async submit() {
    if (this.AIRecognizeInput) {
      this.$message.warning(`有未处理的文本，请点击“智能识别”`);
      return;
    }
    const valid = await this.validate();

    if (!valid) {
      return;
    }
    this.submitting = true;
    const uploadImageRes = await this.imageUploader.upload().catch(() => {
      this.$message.success("商品主图上传失败！");
    });
    if (!uploadImageRes) {
      this.submitting = false;
      return;
    }
    const submitData = await this.getSubmitData();
    const mode = submitData.id ? "modify" : "create";
    const res = await addNewProduct<typeof submitData>(submitData);
    if (res.is_success) {
      this.$message({
        showClose: true,
        message: mode === "create" ? "添加成功" : "修改成功",
        type: "success",
        onClose: () => {
          this.submitting = false;
          this.$emit("success");
        },
      });
    } else {
      this.submitting = false;
    }
  }
  cancel() {
    this.$confirm("确认取消后将不保留当前已编辑的信息", {
      title: "取消",
      confirmButtonText: "确认取消",
      cancelButtonText: "继续填写",
      type: "warning",
    }).then(async () => {
      this.$emit("cancel");
    });
  }
}
